<template>
	<div class="page">
		<div class="search">
			<!-- 			<el-input v-model="searchTxet" size="medium" placeholder="搜索办理签证的国家或地区">
				<img style="width: 1.125rem;height: 1.125rem;" slot="suffix"
					src="../../../static/image/2、签证国家切图/签证国家弹窗搜索图标.png">
			</el-input> -->
			<div class="" style="width: 75rem;height: 100%;margin: 0 auto;position: relative;">
				<img style="width: 1.125rem;height: 1.125rem;right: 0.3125rem;top:50%;transform: translate(-50%, -50%);position: absolute;z-index: 100;"
					src="https://file.aavisa.com/browser-upload-file/d0c89cb8-200e-481b-82c7-631bfdac9b03.jpg">
				<el-select style="width: 100%;" v-model="searchTxet" filterable remote :remote-method="SeachCountry"
					placeholder="搜索办理签证的国家或地区" @change="changeSeach">
					<el-option v-for="item in SeachCountryList" :key="item.id" :label="item.zh_name" :value="item">
					</el-option>
				</el-select>
			</div>

		</div>

		<div class="main">
			<el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top: 1.875rem;">
				<el-tab-pane label="全部" name="all">
					<span slot="label" style="font-size: 1.25rem;">全部</span>

					<div class="main_list" v-if="dataList.length > 0">
						<div class="main_list_item" v-for="(item,index) in dataList" :key="item.name">
							<div class="main_list_item_left">
								{{item.name}}
							</div>
							<div class="main_list_item_right">
								<div class="" v-for="(_item,_index) in item.list" :key="_index"
									@click="goLink(_item.id,_item.zh_name)">
									{{_item.zh_name}}
								</div>
							</div>
						</div>
					</div>

					<el-skeleton v-else :rows="12" animated />
				</el-tab-pane>
				<el-tab-pane v-for="(item,index) in continentsList" :key="item.id" :label="item.name"
					:name="item.value">
					<span slot="label" style="font-size: 1rem;"> {{item.name}}</span>

					<div class="main_list">
						<div class="main_list_item" v-for="(item,index) in dataList" :key="item.name"
							v-show="dataList[index].value == activeName">
							<div class="main_list_item_left">
								{{item.name}}
							</div>
							<div class="main_list_item_right">
								<div class="" v-for="(_item,_index) in item.list" :key="_index"
									@click="goLink(_item.id,_item.zh_name)">
									{{_item.zh_name}}
								</div>
							</div>
						</div>
					</div>

				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				searchTxet: '',
				SeachCountryList: [],
				continentsList: [{
						name: '亚洲',
						id: 1,
						value: 'Asia'
					},
					{
						name: '欧洲',
						id: 2,
						value: 'Europe'
					},
					{
						name: '美洲',
						id: 3,
						value: 'America'
					},
					{
						name: '大洋洲',
						id: 4,
						value: 'Oceania'
					},
					{
						name: '非洲',
						id: 5,
						value: 'Africa'
					},
				],

				activeName: 'all',
				dataList: [{
					name: '亚洲',
					value: 'Asia',
					list: []
				}, {
					name: '欧洲',
					value: 'Europe',
					list: []
				}, {
					name: '美洲',
					value: 'America',
					list: []
				}, {
					name: '大洋洲',
					value: 'Oceania',
					list: [],
				}, {
					name: '非洲',
					value: 'Africa',
					list: []
				}]
			}
		},

		created() {
			this.GetCountrys('all')
		},
		methods: {
			changeSeach(value) {
				this.$router.push(`/detail?id=${value.id}&County=${value.zh_name}`)
			},

			SeachCountry(value) {
				this.$api.SeachCountry({
					keys: value
				}).then(res => {
					let {
						data,
						status
					} = res.data;
					if (status == 200) {
						console.log(data)
						this.SeachCountryList = data.data;

					}
				})
			},

			// 跳转页面
			goLink(id, name) {
				this.$router.push(`/detail?id=${id}&County=${name}`)
			},

			// 点击tabs标签
			handleClick(e) {
				console.log(e.name)
				this.activeName = e.name
			},

			// 获取国家列表
			GetCountrys(name) {
				let that = this;
				let {
					continentsList,
					dataList
				} = this
				let GetCountrys = function(Zone, index = null) {
					that.$api.GetCountrys({
						Zone
					}).then(res => {
						let {
							data,
							status
						} = res.data
						if (status == 200) {
							if (index == 0 || index) {
								dataList[index].list = data
							}
						}
					})
				}
				if (name == 'all') {
					for (let i = 0; i < continentsList.length; i++) {
						GetCountrys(continentsList[i].value, i)
					}
				}
			},
		},
	}
</script>

<style lang='less' scoped>
	.page {
		width: 100%;
		min-height: 92.5rem;
		background-color: #fff;

		.search {
			width: 100%;
			height: 5rem;
			position: relative;
			background-color: #599fff;

		}

		.el-select {
			width: 60.5%;
			height: 2.1875rem;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}

		.el-input {
			width: 60.5%;
			height: 2.1875rem;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);

			/deep/ .el-input__inner {
				height: 100% !important;
				border: none !important;
				border-color: rgba(0, 0, 0, ) !important;
				font-size: 1rem !important;
			}

			/deep/ .el-input__inner::placeholder {
				font-size: 1rem !important;
			}

			/deep/ .el-input__inner:focus {
				border: none !important;
				border-color: rgba(0, 0, 0, ) !important;
			}

			/deep/ .el-input__suffix-inner {
				position: absolute;
				top: 50%;
				right: 10%;
				transform: translate(0%, -50%);
				margin-right: 1.25rem;
			}
		}

		.main {
			width: 75rem;
			height: 87.75rem;
			margin: 0 auto;

			/deep/ .is-active {
				color: #599fff !important;
			}

			/deep/ .el-tabs__item {
				padding: 0 1.875rem;
			}

			/deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2),
			.el-tabs--top .el-tabs__item.is-bottom:nth-child(2),
			.el-tabs--bottom .el-tabs__item.is-top:nth-child(2),
			.el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2) {
				padding-left: 0 !important;
			}

			/deep/ .el-tabs__item:hover {
				color: #2c3e50;
			}

			/deep/ .el-tabs__active-bar {
				background-color: #599fff;
			}

			.main_list {
				width: 100%;
				height: 82rem;

				/* background-color: salmon; */
				.main_list_item {
					width: 100%;
					height: auto;
					display: flex;
					margin: 2.5rem 0;

					.main_list_item_left {
						width: 8.5rem;
						font-size: 1.25rem;
						text-align: left;
					}

					.main_list_item_right {
						width: 66.4375rem;
						display: flex;
						flex-wrap: wrap;
						border-bottom: 1px solid #999999;
						cursor: pointer;

						&>div {
							width: 25%;
							margin-bottom: 1.25rem;
							font-size: 1rem;
							text-align: left;
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/product/country.vue